import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { _AssetItemsByOperationState, _FixedAssetItem } from "../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicButton } from "../../theme/Component/BasicButton";
import { FixedAssetOperationalState } from "./FixedAssetOperationalState/FixedAssetOperationalState";
import { _BusinessProcess, _RequestMaintenance, _single } from "../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { FixedAssetReplacement } from "../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetReplacement/FixedAssetReplacement";
import { RequestMaintenance } from "../../Factoty&Production/Maintenance/RequestMaintenance/RequestMaintenance";
import { SelectorUmeasurement } from "../../bpm/config/Componentes/SelectorUmeasurement";
import { SelectSiteID } from "../../admin/configuracion/SiteID/SelectSiteID";
import { SelectLocationMaintenance } from "../../Factoty&Production/Maintenance/LocationMaintenance/SelectLocationMaintenance";
import { SelectFixedAssetOperationalStateConstants } from "../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/Selectores/SelectFixedAssetOperationalStateConstants";
import { FileInput } from "../../theme/Component/FileInput";
import { InputHours } from "../../theme/Input/InputHours";

interface filters {
    Code: string;
    Placa: number;
    State: number;
}

export const AssetItemsByOperationState = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_RequestMaintenance);
    const fixedAsset = useDataBean(_FixedAssetItem);

    const [form, setform] = useState<Partial<filters>>({})

    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        if (!form.Code && !form.State && !form.Placa) return toast.info("Estado/Placa/Codigo interno es Obligatorio")

        let Props: any = {}

        if (form.Code) Props.InternalCode = form.Code;
        if (form.State) Props.OperationalState = form.State;
        if (form.Placa) Props.TicketCode = form.Placa;

        instance.getFixedAssetItemsMaintenablesRender(paginador.page, 15, Props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                if (resp.List) {
                    resp.List.forEach(element => {
                        const pad = (num: number) => num.toString().padStart(2, '0');

                        const item = element.DataBeanProperties;
                        item.AssetEntity = item.IDFixedAsset ? `${item.IDFixedAsset} - ${item.AssetName}` : "N/A";
                        item.ResponsibleEntity = item.IDAccount ? `${item.AccountNit ?? ""} - ${item.AccountEntity ?? ""}` : "N/P";
                        item.DocumentEntity = item.IDDocument ? `${item.Mnemonic} - ${item.Consecutive}` : "N/A";
                        item.WeigthEntity = item.WeightMeasurementUnit ? `${item.WeightName ?? "N/P"} - ${item.DimWeight ?? "N/P"}` : "N/A";
                        item.LengthEntity = item.LengthMeasurementUnit ? `${item.LengthName ?? "N/P"} - ${item.DimWidth ?? "N/P"} x ${item.DimHeigth}` : "N/A";
                        item.HoraInicio = `${item.HourInitTurn ? `${pad(item.HourInitTurn ?? 0)}:${pad(item.MinuteInitTurn ?? 0)}` : "N/P"}`;
                        item.HoraFin = `${item.HourUptoTurn ? `${pad(item.HourUptoTurn ?? 0)}:${pad(item.MinuteUptoTurn ?? 0)}` : "N/P"}`;

                    });
                    setLista(resp.List)
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDItem', visible: true, MASK: MASK_NUMBER },
        { title: 'Codigo Interno', property: 'InternalCode', visible: true },
        { title: 'Nombre', property: 'AssetEntity', visible: true },
        { title: 'Responsable', property: 'ResponsibleEntity', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Almacen', property: 'StoreName', visible: true },
        { title: 'Ubicación', property: 'SiteName', visible: true },
        { title: 'Modelo Operativo', property: 'SupplierModel', visible: true },
        { title: 'Dimensiones', property: 'LengthEntity', visible: true },
        { title: 'Peso', property: 'WeigthEntity', visible: true },
        { title: 'Inicio de Turno', property: 'HoraInicio', visible: true },
        { title: 'Fin de Turno', property: 'HoraFin', visible: true },
        { title: 'Area de Mantenimiento', property: 'MaintenanceName', visible: true },
    ]

    const modalRequest = useModal("Iniciar Solicitud de Mantenimiento", MODAL_md);
    const modalChange = useModal("Confirmar Ractivación del Implemento", MODAL_md);
    const modalChange2 = useModal("Confirmar Detenecion del Implemento", MODAL_md);
    const modalReplacement = useModal(`Catalogo de Repuestos Solicitados de ${bean.AssetEntity}`, MODAL_md);
    const modalWorkMaintenance = useModal(`Mantenimientos Relizados de ${bean.AssetEntity}`, MODAL_XL);
    const modal = useModal(`Editar infomación de ${bean.AssetEntity}`, MODAL_LG);

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open() } },
            { titulo: 'Solicitar Mantenimiento', icono: 'ri-settings-5-fill', visible: (bean.OperationalState == 34 && _single.canEdit()), evento: () => { setRequest({}); modalRequest.open() } },
            { titulo: 'Marcar Implemento en uso', icono: 'ri-swap-box-line', visible: (bean.OperationalState == 34 && _single.canEdit()), evento: () => { modalChange.open() } },
            { titulo: 'Detener Implemento', icono: 'ri-swap-box-line', visible: (bean.OperationalState == 32 && _single.canEdit()), evento: () => { modalChange2.open() } },
            { titulo: 'Consultar Catalogo de Repuestos Utilizados', icono: 'ri-file-settings-line', visible: true, evento: () => { modalReplacement.open() } },
            { titulo: 'Consultar Mantenimientos Relizados', icono: 'ri-file-settings-line', visible: true, evento: () => { modalWorkMaintenance.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [request, setRequest] = useState<any>({});
    const _bProcess = useDataBean(_BusinessProcess);
    const maintenance = useDataBean(_RequestMaintenance);

    const startProcess = () => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        const payload = JSON.stringify({ ...bean, IDAccount: _single.getAccountID(), });

        _bProcess.instance.requestBusinessProcess(
            _single.getAccountID(),
            request.Obs,
            "SOLMD",
            "IDFixedAssetItem",
            bean.IDItem,
            payload,
            ""
        ).then((resp) => {
            toast.success(`Se ha iniciado el proceso con IDProcedureImp ${resp.AlphaCode}`);
            maintenance.instance.updateRequestMaintenance({
                IDProceudreIMP: resp.IDProcedureImp,
                IDLocation: bean.IDLnSiteID,
                IDLocationName: bean.SiteIDName,
                IDFixedAssetItem: bean.IDItem,
                IDFixedAsset: bean.IDFixedAsset,
                IDFixedAssetItemName: bean.AssetEntity,
                IDEmployee: _single.getAccountID(),
                AlphaCodeProcedure: resp.AlphaCode,
                ReportDate: _single.getCurrenDate(),
                IsPlan: false,
                ReportTimeH: currentHour,
                ReportTimeM: currentMinute,
                State: 1,
            }).then(
                (resp) => {
                    modalRequest.close();
                    updateStateItem(33);
                }
            ).catch(
                err => {
                    toast.error("No se pudo realizar la acción")
                }
            )
        }).catch(() => toast.error("No se ha podido iniciar el proceso"));
    };

    const updateStateItem = (Sttate: number) => {
        fixedAsset.instance.setOperationalStateToFixedAssetItem(bean.IDItem, Sttate, _single.getAccountID()).then(
            (resp) => {
                getLista();
                setBean({})
                modalChange.close()
                modalChange2.close()
            }
        ).catch(err => { toast.error(err) })
    }

    const editaItem = () => {
        fixedAsset.updateCustonBean(bean).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <BasicPage titulo="Catálogo de Activos por Estado Operativo">
            <div className="row">
                <div className="col-md-4">
                    <label>Placa</label>
                    <input type="number" value={form.Placa} onChange={(e) => { setform({ ...form, Placa: Number(e.target.value) }) }} className="form-control" />
                </div>
                <div className="col-md-4">
                    <FixedAssetOperationalState idSelector={form.State} onChange={(e) => { setform({ ...form, State: e }) }} />
                </div>
                <div className="col-md-4">
                    <label>Codigo Interno</label>
                    <input type="text" value={form.Code} onChange={(e) => { setform({ ...form, Code: e.target.value }) }} className="form-control" />
                </div>
                <div className="col-md-3 mt-4 p-2">
                    <BasicButton icon="ri-search-line" clase="btn btn-primary waves-effect waves-light" eventClick={() => { getLista() }}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable
                        listButtons={listaBotones()}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={15}
                    />
                    <Modal modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={() => { startProcess() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <label>Justificación</label>
                                <textarea className="form-control" value={request.Obs} onChange={(e) => { setRequest({ ...request, Obs: e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>

                    <Modal modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { updateStateItem(32) }} >
                        <div className="row">
                            <div className="col-md-12">
                                <p>
                                    ¿Desea reactivar el implemento {bean.Name}?
                                </p>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalChange2.modal} updateModal={modalChange2.setModal} eventModal={() => { updateStateItem(34) }} >
                        <div className="row">
                            <div className="col-md-12">
                                <p>
                                    ¿Desea parar el implemento {bean.Name}?
                                </p>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalReplacement.modal} updateModal={modalReplacement.setModal} >
                        <FixedAssetReplacement idItem={bean.IDItem} />
                    </Modal>

                    <Modal modal={modalWorkMaintenance.modal} updateModal={modalWorkMaintenance.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <RequestMaintenance isModal filterProps={{ IDFixedAssetItem: bean.IDItem }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <FileInput
                                    label="Imagen"
                                    previsualization
                                    Media={bean.Media}
                                    MediaContext={bean.MediaContext}
                                    docAcept="image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/svg+xml"
                                    onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }}
                                />
                            </div>
                            <div className="col-md-6">
                                <SelectFixedAssetOperationalStateConstants idSelector={bean.OperationalState} onChange={(e) => { setBean({ ...bean, OperationalState: e }) }} label="Estado Operativo" />
                            </div>
                            <div className="col-md-6">
                                <label>Código Interno de Referencia</label>
                                <input type="text" className="form-control" value={bean.InternalCode} onChange={(e) => { setBean({ ...bean, InternalCode: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputHours _value={{ Hour: bean.HourInitTurn, Minute: bean.MinuteInitTurn }} onChange={(e) => {
                                    setBean({ ...bean, HourInitTurn: e.Hour, MinuteInitTurn: e.Minute })
                                }} _label="Inicio de Turno" />
                            </div>

                            <div className="col-md-6">
                                <InputHours _value={{ Hour: bean.HourUptoTurn, Minute: bean.MinuteUptoTurn }} onChange={(e) => {
                                    setBean({ ...bean, HourUptoTurn: e.Hour, MinuteUptoTurn: e.Minute })
                                }} _label="Fin de Turno" />
                            </div>
                            <div className="col-md-6">
                                <label>Modelo Operativo</label>
                                <input type="text" className="form-control" value={bean.SupplierModel} onChange={(e) => { setBean({ ...bean, SupplierModel: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Dimensiones</label>
                                <div className="row">
                                    <div className="col-md-5">
                                        <input type="number" className="form-control" value={bean.DimWidth} onChange={(e) => {
                                            const value = e.target.value ? parseFloat(e.target.value) : null;
                                            setBean({ ...bean, DimWidth: value });
                                        }} />
                                    </div>
                                    <div className="col-md-2 d-flex align-content-center justify-content-center">x</div>
                                    <div className="col-md-5">
                                        <input type="number" className="form-control" value={bean.DimHeigth} onChange={(e) => {
                                            const value = e.target.value ? parseFloat(e.target.value) : null;
                                            setBean({ ...bean, DimHeigth: value });
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <SelectorUmeasurement idSelector={bean.LengthMeasurementUnit} onChange={(e) => { setBean({ ...bean, LengthMeasurementUnit: e }) }} titulo="Unidad Medida de Dimensiones" />
                            </div>
                            <div className="col-md-6">
                                <label>Peso</label>
                                <input type="number" className="form-control" value={bean.DimWeight} onChange={(e) => {
                                    const value = e.target.value ? parseFloat(e.target.value) : null;
                                    setBean({ ...bean, DimWeight: value });
                                }} />
                            </div>
                            <div className="col-md-6">
                                <SelectorUmeasurement idSelector={bean.WeightMeasurementUnit} onChange={(e) => { setBean({ ...bean, WeightMeasurementUnit: e }) }} titulo="Unidad Medida de Peso" />
                            </div>
                            <div className="col-md-6">
                                <label>Ubicación Geográfica</label>
                                <SelectSiteID onChange={(e) => { setBean({ ...bean, IDLnSiteID: e.IDLn }) }} edit={false} idLnSite={bean.IDLnSiteID} />
                            </div>

                            <div className="col-md-6">
                                <SelectLocationMaintenance idSelector={bean.IDLocationMaintenance} onChange={(e) => { setBean({ ...bean, IDLocationMaintenance: e }) }} label="Area de Mantenimiento" />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}